export const REIUMBURSEMENT_TAB_DATA_OVERVIEW_API= 'claims-overturn-metrics';
export const REIUMBURSEMENT_TAB_DATA_METRICS_API= 'claim-metrics/?request-type=PAYMENT_METRICS';
export const REIUMBURSEMENT_TAB_DATA_DOP_FILTERS_API= 'dop-claim-metrics/?request-type=CLAIMS';
export const REIUMBURSEMENT_TAB_APPEALS_DETAILS_API= 'claims-appeals-summary';
export const REIUMBURSEMENT_TAB_RECONSIDERATION_DETAILS_API= 'claims-recon-details/';
export const REIUMBURSEMENT_TAB_RECONSIDERATION_DETAILS_API_BULK= 'claims-recon-details'; 
export const REIUMBURSEMENT_TAB_NONPAYMENT_API= 'claims-bifurcate-metrics/';
export const REIUMBURSEMENT_TAB_NONPAYMENT_BULK_API = 'claims-bifurcate-metrics';
export const REIUMBURSEMENT_TAB_DATA_DOP_BULK_FILTERS_API= 'dop-claim-metrics?request-type=CLAIMS';
